import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserService } from '../../core/users/services/user.service';
import { LocalStorageID } from '../entities/local-storage-ids.entity';

@Injectable({ providedIn: 'root' })
export class LocalStorageStateService {
    public isInitialized$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private userId: string;

    private readonly userService: UserService = inject(UserService);

    constructor() {
        this.userService
            .getCurrentUser()
            .pipe(map(user => user.Id))
            .subscribe((userId: string) => {
                this.userId = userId;
                this.isInitialized$.next(true);
            });
    }

    // #region Getters and Setters
    getState(localStorageId: LocalStorageID): any | null {
        const localStorageState: string | null = localStorage.getItem(
            this.getLocalStorageKey(localStorageId, this.userId)
        );

        return localStorageState ? JSON.parse(localStorageState) : null;
    }

    setState(localStorageId: LocalStorageID, updatedState: any): void {
        localStorage.setItem(this.getLocalStorageKey(localStorageId, this.userId), JSON.stringify(updatedState));
    }
    // #endregion

    private getLocalStorageKey(localStorageId: LocalStorageID, userId: string): string {
        return `${localStorageId}-${userId}`;
    }
}
